import React from 'react';
import { Link } from 'react-router-dom';
import Helper from '../Utils/Helpers';
import { routes } from '../Routing/routes';

export class NotFound extends React.Component<any, any> {
	componentDidMount() {
		Helper.setLoader(false);
	}

	render() {
		return (
			<div
				style={{
					position: 'fixed',
					height: '200px',
					width: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'flex-start',
					flexDirection: 'column',
				}}
			>
				<h1 style={{ fontSize: '38px', width: '100%', textAlign: 'center' }}>Strona nie istnieje</h1>
				<Link to={routes.root} className='btn btn-primary' style={{ margin: '0 auto' }}>
					Wróć do strony głównej
				</Link>
			</div>
		);
	}
}
